module.exports = __webpack_public_path__ + "static/media/notification_update_icon.190038d6.svg";